export default "__VITE_ASSET__CdNe$vpy__"